/**
 * დასწრების ფერითი ზონა — ერთი წესი მთელ UI-ზე.
 * ზღვრები `settings`-იდან მოდის, ამიტომ ადმინის ცვლილება ყველგან აისახება.
 */

export type Thresholds = {
  risk_threshold: number;
  yellow_threshold: number;
  red_threshold: number;
};

const DEFAULTS: Thresholds = { risk_threshold: 75, yellow_threshold: 65, red_threshold: 51 };

export const ZONE_COLORS = {
  green: '#17795e',
  yellow: '#b06f10',
  red: '#b42318',
  grey: '#98a2b3',
} as const;

export type Zone = keyof typeof ZONE_COLORS;

export function attendanceZone(
  pct: number | null | undefined,
  thresholds: Partial<Thresholds> | undefined | null,
): Zone {
  if (pct === null || pct === undefined || Number.isNaN(pct)) return 'grey';
  const t = { ...DEFAULTS, ...(thresholds ?? {}) };
  if (pct < t.red_threshold) return 'red';
  if (pct < t.risk_threshold) return 'yellow';
  return 'green';
}

export function zoneColor(
  pct: number | null | undefined,
  thresholds?: Partial<Thresholds> | null,
): string {
  return ZONE_COLORS[attendanceZone(pct, thresholds)];
}

/** Tailwind კლასები ტექსტისთვის */
export function zoneTextClass(
  pct: number | null | undefined,
  thresholds?: Partial<Thresholds> | null,
): string {
  const zone = attendanceZone(pct, thresholds);
  return {
    green: 'text-ok',
    yellow: 'text-warn',
    red: 'text-danger',
    grey: 'text-ink-mute',
  }[zone];
}
